<t4-header>
  <button mat-button (click)="signPTInvoices()" *ngIf="Settings.isInAny(['BackOffice']) && unsignedPtInvoices"><mat-icon>send</mat-icon>{{'T4CC.Invoices.cmdSignInvoices' | translate : 'Sign paythrough' }}</button>
  <button mat-button (click)="signPTInvoices()" *ngIf="Settings.getUser().Username == 'Björn' && unsignedPtInvoices"><mat-icon>send</mat-icon>{{'T4CC.Invoices.cmdSignInvoices' | translate : 'Sign paythrough' }}</button>
</t4-header>
<t4-container title="{{ 'T4CC.Invoices.PendingHeadline' | translate : 'Pending invoices' }}">
  <t4-data-table apiMethod="CC/GetPendingInvoices" matSortActive="GeneratedAt" matSortDirection="desc" headline="{{ 'T4CC.Invoices.Headline' | translate : 'Invoices' }}" [autoGenerateColumns]="false" matSort [filterFields]="['InvoiceAccount', 'SalesId', 'MessageId']">
    <ng-container matColumnDef="Id">
      <mat-header-cell *matHeaderCellDef style="max-width: 75px;"></mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 75px;" (click)="open(row.Id)"><mat-icon style="color: red;" *ngIf="!row.SalesId && !row.IsProcessing">block</mat-icon><mat-icon *ngIf="row.SalesId || row.IsProcessing">receipt</mat-icon></mat-cell>
    </ng-container>
    <ng-container matColumnDef="SalesId">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 100px">{{ 'T4CC.Invoices.lblSalesIdt' |translate : 'Sales id' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="width: 100px" (click)="open(row.Id)">{{ row.SalesId }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="InvoiceAccount">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'T4CC.Invoices.lblInvoiceAccount' |translate : 'Invoice account' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="open(row.Id)">{{ row.InvoiceAccount }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="CustomerName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'T4CC.Invoices.lblCustomerName' |translate : 'Customer name' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="open(row.Id)">{{ row.CustomerName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="LineCount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 50px">{{ 'T4CC.Invoices.lblLineCount' |translate : 'Lines' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="width: 50px" (click)="open(row.Id)">{{ row.LineCount }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="InvoiceAmount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 100px">{{ 'T4CC.Invoices.lblInvoiceAmount' |translate : 'Amount' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="width: 100px" (click)="open(row.Id)">{{ row.InvoiceAmount | currency }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="VatAmount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 100px">{{ 'T4CC.Invoices.lblVatAmount' |translate : 'Vat' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="width: 100px" (click)="open(row.Id)">{{ row.VatAmount | currency }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="GeneratedAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 125px;">{{ 'T4CC.Invoices.lblGenerated' |translate : 'Created' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 125px;" (click)="open(row.Id)">{{ row.GeneratedAt | date : 'yyyy-MM-dd HH:mm' }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="CompletedAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 125px">{{ 'T4CC.Invoices.lblCompletedAt' |translate : 'Processed' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="width: 125px" (click)="open(row.Id)">{{ row.CompletedAt | date : 'yyyy-MM-dd HH:mm' }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="MessageId">
      <mat-header-cell *matHeaderCellDef style="max-width: 150px;"></mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 150px;">
        <button mat-icon-button color="primary" (click)="resend(row)" *ngIf="!row.SalesId && !row.IsProcessing">
          <mat-icon>send</mat-icon>
        </button>
        <button mat-icon-button (click)="resend(row)" *ngIf="row.SalesId || row.IsProcessing">
          <mat-icon>send</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
